import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ISalonsSearchResultsItem } from '@app/salons-search-results/models/salons-search-results-item.model';
import {
  getSalonLogoUrlOrDefault,
  getGoogleMapsUrlFromSalonAdress,
  getSalonPictureUrlOrDefault
} from '@app/shared/utils/salon';

@Component({
  selector: 'app-salons-search-results-item',
  templateUrl: './salons-search-results-item.component.html',
  styleUrls: ['./salons-search-results-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SalonsSearchResultsItemComponent implements OnInit {

  @Input() item: ISalonsSearchResultsItem;
  @Input() cityName?: string;
  googleMapsUrl = '';
  pictureUrl = '';
  logoUrl = '';

  constructor() { }

  ngOnInit(): void {
    this.googleMapsUrl = getGoogleMapsUrlFromSalonAdress(this.item);
    this.pictureUrl = getSalonPictureUrlOrDefault(this.item.pictureUrl);
    this.logoUrl = getSalonLogoUrlOrDefault(this.item.logoUrl);
  }

}
